<template>
    <div id="app">
        <div class="logo">
            <el-image style="width: 100%" src="https://www.vibe-vape.com/images/logo.png" fit="cover"></el-image>
        </div>
        <div class="language">
            <div class="pointer">中</div>
            <div class="language-center">|</div>
            <div class="pointer">E</div>
        </div>

        <full-page ref="fullpage" :options="options" id="fullpage">
            <div class="section">
<!--                <h3>{{ $t("page1.slide1.title") }}</h3>-->
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section1_slide1 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/shutterstock_1219537795.png" fit="cover"></el-image>
                            <div class="let-be" @click="show_section1_slide1 = 1">TASTE THE VIBE</div>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="show_section1_slide1 = 1">了 解 更 多</span>
                                </div>
                                <el-image class="pointer" @click="show_section1_slide1 = 1" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in">
                        <div v-show="show_section1_slide1 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D-18.jpg" fit="cover" ></el-image>
                            <el-image style="height: 50%;position: absolute;left:0; right:0;top: 30%" src="https://www.vibe-vape.com/images/RD.png" fit="scale-down"></el-image>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="show_section1_slide1 = 2">了 解 更 多</span>
                                </div>
                                <el-image class="pointer" @click="show_section1_slide1 = 2" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section1_slide1 === 2" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D_V2-25.jpg" fit="cover" ></el-image>
                            <el-image style="width: 50%;height: 60%;position: absolute;left:0; right:0;top: 20%" src="https://www.vibe-vape.com/images/RD.png" fit="scale-down"></el-image>
                            <div class="right-detail">
                                <div class="right-detaiil-titel">
                                    <div>Ribbon Red</div>
                                    <div>缨 果 红</div>
                                </div>
                                <div class="right-detaiil-content">
                                    <div>知性是不落俗套 更是雕刻青春</div>
                                    <div>手中握着对生活的热忱 追逐奋进</div>
                                </div>
                                <div class="right-detaiil-buy" @click="toJd">立即购买</div>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section1_slide2 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/COVER-SHOT-WOMAN2.jpg" fit="cover" ></el-image>
                            <div class="slide-mask"></div>
                            <div class="let-be" @click="show_section1_slide2 = 1">EAGER FOR BETTER</div>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="show_section1_slide2 = 1">了 解 更 多</span>
                                </div>
                                <el-image class="pointer" @click="show_section1_slide2 = 1" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in">
                        <div v-show="show_section1_slide2 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D-17.jpg" fit="cover" ></el-image>
                            <el-image style="height: 50%;position: absolute;left:0; right:0;top: 30%" src="https://www.vibe-vape.com/images/R.png" fit="scale-down"></el-image>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="show_section1_slide2 = 2">了 解 更 多</span>
                                </div>
                                <el-image class="pointer" @click="show_section1_slide2 = 2" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                            <!--                        <el-image class="slide-img" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D-18.jpg" fit="cover"></el-image>-->
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section1_slide2 === 2" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D_V2-26.jpg" fit="cover" ></el-image>
                            <el-image style="width: 50%;height: 60%;position: absolute;left:50%; right:0;top: 20%" src="https://www.vibe-vape.com/images/R.png" fit="scale-down"></el-image>
                            <div class="left-detail">
                                <div class="right-detaiil-titel">
                                    <div>Simple Blue</div>
                                    <div>浅 夏 蓝</div>
                                </div>
                                <div class="right-detaiil-content">
                                    <div>在时光轻语中与岁月同行</div>
                                    <div>四季更替不及浅夏至诚 赋予未来更多可能</div>
                                </div>
                                <div class="right-detaiil-buy" @click="toJd">立即购买</div>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section1_slide3 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/shutterstock_526304581_R.jpg" fit="cover" ></el-image>
                            <div class="slide-mask"></div>
                            <el-image style="height: 50%;position: absolute;left:0; right:0;top: 30%" src="https://www.vibe-vape.com/images/G.png" fit="scale-down"></el-image>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="show_section1_slide3 = 1">了 解 更 多</span>
                                </div>
                                <el-image class="pointer" @click="show_section1_slide3 = 1" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                            <!--                        <el-image class="slide-img" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D-18.jpg" fit="cover"></el-image>-->
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section1_slide3 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D_V2-28.jpg" fit="cover" ></el-image>
                            <el-image style="width: 50%;height: 60%;position: absolute;left:0; right:0;top: 20%" src="https://www.vibe-vape.com/images/G.png" fit="scale-down"></el-image>
                            <div class="right-detail">
                                <div class="right-detaiil-titel">
                                    <div>Yuppie Gray</div>
                                    <div>雅 痞 灰</div>
                                </div>
                                <div class="right-detaiil-content">
                                    <div>用进退有度的姿态展示自己独具一格的不俗品味</div>
                                    <div>表达我的观点 无问东西</div>
                                </div>
                                <div class="right-detaiil-buy" @click="toJd">立即购买</div>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section1_slide4 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/COVER-SHOT-MAN21.jpg" fit="cover" ></el-image>
                            <div class="slide-mask"></div>
                            <div class="let-be" @click="show_section1_slide4 = 1">Let's Be The Vibers！</div>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="show_section1_slide4 = 1">了 解 更 多</span>
                                </div>
                                <el-image class="pointer" @click="show_section1_slide4 = 1" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in">
                        <div v-show="show_section1_slide4 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D-16.jpg" fit="cover" ></el-image>
                            <el-image style="height: 50%;position: absolute;left:0; right:0;top: 30%" src="https://www.vibe-vape.com/images/B.png" fit="scale-down"></el-image>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="show_section1_slide4 = 2">了 解 更 多</span>
                                </div>
                                <el-image class="pointer" @click="show_section1_slide4 = 2" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                            <!--                        <el-image class="slide-img" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D-18.jpg" fit="cover"></el-image>-->
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section1_slide4 === 2" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D_V2-27.jpg" fit="cover" ></el-image>
                            <el-image style="width: 50%;height: 60%;position: absolute;left:50%; right:0;top: 20%" src="https://www.vibe-vape.com/images/B.png" fit="scale-down"></el-image>
                            <div class="left-detail">
                                <div class="right-detaiil-titel">
                                    <div>Iconic Black</div>
                                    <div>典 雅 黑</div>
                                </div>
                                <div class="right-detaiil-content">
                                    <div>尽情展望 黑是无尽未来</div>
                                    <div>精彩在于不可知的无尽希望 随性间深邃且神秘</div>
                                </div>
                                <div class="right-detaiil-buy" @click="toJd">立即购买</div>
                            </div>
                        </div>
                    </transition>
                </div>

                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section1_slide5 === 0" class="transition-box sp-detail" :style="{'height': windowsHeight+'px'}" style="position: relative;">
                            <el-image class="slide-img" style="height: 94%" src="https://www.vibe-vape.com/images/speciality-1.png" fit="scale-down"></el-image>
                            <div class="sp-left">
                                <div style="position: absolute;top: 31%;right: 10%;">
                                    <div>电子雾化液仓容量：1.5ml/个</div>
                                    <div>每个电子雾化器口数：约400口</div>
                                    <div>(机器测试，实际口数因人而异)</div>
                                </div>
                            </div>
                            <div class="sp-right">
                                <div style="position: absolute;top: 40%;left: 14%;">
                                    <div>雾化杆</div>
                                    <div>电池容量：370mAh</div>
                                    <div>充电时间：约50分钟</div>
                                </div>
                                <div style="position: absolute;top: 56%;left: 14%;">
                                    <div>指示灯</div>
                                    <div>长亮：充电状态</div>
                                    <div>灯灭：电池充满</div>
                                    <div>连续闪烁10次：低电量，抽吸⽆输出</div>
                                    <div>充电状态，可正常工作。</div>
                                </div>
                                <div style="position: absolute;top: 76%;left: 14%;">
                                    <div>充电接口：Micro-USB接口，随插随充</div>
                                </div>
                            </div>
                            <div class="speciality" @click="show_section1_slide5 = 1"></div>
                            <div class="free-logo">
                                <el-image class="pointer" style="width: 5%" src="https://www.vibe-vape.com/images/FEELM logo-02.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section1_slide5 === 1" class="transition-box sp-detail" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" style="height: 94%" src="https://www.vibe-vape.com/images/speciality-2.png" fit="scale-down"></el-image>
                            <div class="sp-left">
                                <div style="position: absolute;top: 26%;right: 10%;">
                                    <div>电子雾化液仓容量：1.5ml/个</div>
                                    <div>每个电子雾化器口数：约400口</div>
                                    <div>(机器测试，实际口数因人而异)</div>
                                </div>
                                <div style="position: absolute;top: 37%;right: 12%;font-weight: bold;color: white;">
                                    <div>电子雾化液</div>
                                    <div>主要成分：天然植物甘油、</div>
                                    <div>食品级丙二醇、</div>
                                    <div>天然植物提取物、植物碱</div>
                                </div>
                            </div>
                            <div class="sp-right">
                                <div style="position: absolute;top: 34%;left: 14%;font-weight: bold;color: white;">
                                    <div>雾化芯：</div>
                                    <div>全新一代FEELM-黑陶覆膜雾化芯</div>
                                    <div>上亿雾化孔均匀受热</div>
                                    <div>纳米级精准雾化</div>
                                </div>
                                <div style="position: absolute;top: 46%;left: 14%;">
                                    <div>雾化杆</div>
                                    <div>电池容量：370mAh</div>
                                    <div>充电时间：约50分钟</div>
                                </div>
                                <div style="position: absolute;top: 62%;left: 14%;">
                                    <div>指示灯</div>
                                    <div>长亮：充电状态</div>
                                    <div>灯灭：电池充满</div>
                                    <div>连续闪烁10次：低电量，抽吸⽆输出</div>
                                    <div>充电状态, 可正常工作。</div>
                                </div>
                                <div style="position: absolute;top: 82%;left: 14%;">
                                    <div>充电接口：Micro-USB接口，随插随充</div>
                                </div>
                            </div>
                            <div class="speciality" @click="show_section1_slide5 = 0"></div>
                            <div class="free-logo">
                                <el-image class="pointer" style="width: 5%" src="https://www.vibe-vape.com/images/FEELM logo-02.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>

            <div class="section">
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section2_slide1 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/m7hdSXUr5KxtUunN.jpg" fit="cover" ></el-image>
                            <div class="slide-mask"></div>
                            <div class="cap-line">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/CAP_line.png" fit="cover" ></el-image>
                            </div>
                            <div class="more-right">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/right.png" fit="cover" @click="show_section2_slide1 = 1" ></el-image>
                            </div>
                            <div class="six-flavors">
                                <div>TOBACCO</div>
                                <div>醇 香 本 草</div>
                            </div>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="nextSlide(1)">解 锁 更 多</span>
                                </div>
                                <el-image class="pointer" @click="nextSlide(1)" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section2_slide1 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="background-color: #3E2E22;display: flex;flex-direction: row;height: inherit">
                                <el-image style="width: 50%;height: 100%;" src="https://www.vibe-vape.com/images/m7hdSXUr5KxtUunN.jpg" fit="cover" ></el-image>
                                <div style="width: 50%;height: 100%;"></div>
                            </div>
                            <div class="slide-mask"></div>
                            <el-image style="height: 46%;position: absolute;left:0; right:0;top: 27%" src="https://www.vibe-vape.com/images/CAP.png" fit="scale-down"></el-image>
                            <div class="right-detail">
                                <div class="right-detaiil-titel">
                                    <div>TOBACCO</div>
                                    <div>醇 香 本 草</div>
                                </div>
                                <div class="right-detaiil-content">
                                    <div>单纯诠释本草内涵, 醇厚平和环绕口腔,</div>
                                    <div>缕缕充实满足。</div>
                                </div>
                                <div class="right-detaiil-buy" @click="toJd">立即购买</div>
                            </div>
                            <div class="detail-back">
                                <el-image class="pointer" style="width: 4%" src="https://www.vibe-vape.com/images/left-white.png" fit="cover" @click="show_section2_slide1 = 0" ></el-image>
                            </div>
                         </div>
                    </transition>
                </div>
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section2_slide2 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/shutterstock_745949110.jpg" fit="cover" ></el-image>
                            <div class="cap-line">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/CAP_line.png" fit="cover"></el-image>
                            </div>
                            <div class="more-right">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/right.png" fit="cover" @click="show_section2_slide2 = 1"></el-image>
                            </div>
                            <div class="six-flavors">
                                <div>CHINESE SPIRIT</div>
                                <div>绵 柔 酒 香</div>
                            </div>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="nextSlide(2)">解 锁 更 多</span>
                                </div>
                                <el-image class="pointer" @click="nextSlide(2)" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section2_slide2 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="background-color: #C4AF91;display: flex;flex-direction: row;height: inherit">
                                <el-image style="width: 50%;height: 100%;" src="https://www.vibe-vape.com/images/shutterstock_745949110.jpg" fit="cover" ></el-image>
                                <div style="width: 50%;height: 100%;"></div>
                            </div>
                            <el-image style="height: 46%;position: absolute;left:0; right:0;top: 27%" src="https://www.vibe-vape.com/images/CAP.png" fit="scale-down"></el-image>
                            <div class="right-detail">
                                <div class="right-detaiil-titel">
                                    <div>CHINESE SPIRIT</div>
                                    <div>绵 柔 酒 香</div>
                                </div>
                                <div class="right-detaiil-content">
                                    <div>入口绵密, 清柔甘爽</div>
                                    <div>畅享酒不醉人香自醉的细腻悠长。</div>
                                </div>
                                <div class="right-detaiil-buy" @click="toJd">立即购买</div>
                            </div>
                            <div class="detail-back">
                                <el-image class="pointer" style="width: 4%" src="https://www.vibe-vape.com/images/left-white.png" fit="cover" @click="show_section2_slide2 = 0"></el-image>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section2_slide3 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/5cc10d09f21c9.jpg" fit="cover" ></el-image>
                            <div class="cap-line">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/CAP_line.png" fit="cover"></el-image>
                            </div>
                            <div class="more-right">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/right.png" fit="cover" @click="show_section2_slide3 = 1"></el-image>
                            </div>
                            <div class="six-flavors">
                                <div>CITRUS</div>
                                <div>回 甘 陈 皮</div>
                            </div>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="nextSlide(3)">解 锁 更 多</span>
                                </div>
                                <el-image class="pointer" @click="nextSlide(3)" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section2_slide3 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="background-color: #672720;display: flex;flex-direction: row;height: inherit">
                                <el-image style="width: 50%;height: 100%;" src="https://www.vibe-vape.com/images/5cc10d09f21c9.jpg" fit="cover" ></el-image>
                                <div style="width: 50%;height: 100%;"></div>
                            </div>
                            <el-image style="height: 46%;position: absolute;left:0; right:0;top: 27%" src="https://www.vibe-vape.com/images/CAP.png" fit="scale-down"></el-image>
                            <div class="right-detail">
                                <div class="right-detaiil-titel">
                                    <div>CITRUS</div>
                                    <div>回 甘 陈 皮</div>
                                </div>
                                <div class="right-detaiil-content">
                                    <div>陈年香气激发垂涎感, 啖啖回甘,</div>
                                    <div>口口生津</div>
                                </div>
                                <div class="right-detaiil-buy" @click="toJd">立即购买</div>
                            </div>
                            <div class="detail-back">
                                <el-image class="pointer" style="width: 4%" src="https://www.vibe-vape.com/images/left-white.png" fit="cover" @click="show_section2_slide3 = 0"></el-image>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section2_slide4 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/shutterstock_1256124910.jpg" fit="cover" ></el-image>
                            <div class="cap-line">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/CAP_line.png" fit="cover"></el-image>
                            </div>
                            <div class="more-right">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/right.png" fit="cover" @click="show_section2_slide4 = 1"></el-image>
                            </div>
                            <div class="six-flavors">
                                <div>PINEAPPLE</div>
                                <div>仲 夏 菠 萝</div>
                            </div>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="nextSlide(4)">解 锁 更 多</span>
                                </div>
                                <el-image class="pointer" @click="nextSlide(4)" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section2_slide4 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="background-color: #F8AC2A;display: flex;flex-direction: row;height: inherit">
                                <el-image style="width: 50%;height: 100%;" src="https://www.vibe-vape.com/images/shutterstock_1256124910.jpg" fit="cover"></el-image>
                                <div style="width: 50%;height: 100%;"></div>
                            </div>
                            <el-image style="height: 46%;position: absolute;left:0; right:0;top: 27%" src="https://www.vibe-vape.com/images/CAP.png" fit="scale-down"></el-image>
                            <div class="right-detail">
                                <div class="right-detaiil-titel">
                                    <div>PINEAPPLE</div>
                                    <div>夏 日 菠 萝</div>
                                </div>
                                <div class="right-detaiil-content">
                                    <div>呼入阳光沙滩, 吸出满溢果香,</div>
                                    <div>唤醒仲夏味蕾之旅</div>
                                </div>
                                <div class="right-detaiil-buy" @click="toJd">立即购买</div>
                            </div>
                            <div class="detail-back">
                                <el-image class="pointer" style="width: 4%" src="https://www.vibe-vape.com/images/left-white.png" fit="cover" @click="show_section2_slide4 = 0"></el-image>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section2_slide5 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/o.51660.jpg" fit="cover" ></el-image>
                            <div class="cap-line">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/CAP_line.png" fit="cover"></el-image>
                            </div>
                            <div class="more-right">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/right.png" fit="cover" @click="show_section2_slide5 = 1"></el-image>
                            </div>
                            <div class="six-flavors">
                                <div>ICE MINT</div>
                                <div>沁 爽 薄 荷</div>
                            </div>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="nextSlide(5)">解 锁 更 多</span>
                                </div>
                                <el-image class="pointer" @click="nextSlide(5)" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section2_slide5 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="background-color: #7498B5;display: flex;flex-direction: row;height: inherit">
                                <el-image style="width: 50%;height: 100%;" src="https://www.vibe-vape.com/images/o.51660.jpg" fit="cover" ></el-image>
                                <div style="width: 50%;height: 100%;"></div>
                            </div>
                            <el-image style="height: 46%;position: absolute;left:0; right:0;top: 27%" src="https://www.vibe-vape.com/images/CAP.png" fit="scale-down"></el-image>
                            <div class="right-detail">
                                <div class="right-detaiil-titel">
                                    <div>ICE MINT</div>
                                    <div>沁 爽 薄 荷</div>
                                </div>
                                <div class="right-detaiil-content">
                                    <div>“冻”力十足, 焕发清新活力,</div>
                                    <div>冰爽口感, 激发灵感肆意</div>
                                </div>
                                <div class="right-detaiil-buy" @click="toJd">立即购买</div>
                            </div>
                            <div class="detail-back">
                                <el-image class="pointer" style="width: 4%" src="https://www.vibe-vape.com/images/left-white.png" fit="cover" @click="show_section2_slide5 = 0"></el-image>
                            </div>
                        </div>
                    </transition>
                </div>
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section2_slide6 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <el-image class="slide-img" src="https://www.vibe-vape.com/images/shutterstock_1104499724.jpg" fit="cover" ></el-image>
                            <div class="cap-line">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/CAP_line.png" fit="cover"></el-image>
                            </div>
                            <div class="more-right">
                                <el-image style="width: 100%" src="https://www.vibe-vape.com/images/right.png" fit="cover" @click="show_section2_slide6 = 1"></el-image>
                            </div>
                            <div class="six-flavors">
                                <div>ICE COFFEE</div>
                                <div>冰 醇 咖 啡</div>
                            </div>
                            <div class="know-more">
                                <div>
                                    <span class="pointer" @click="nextSlide(6)">解 锁 更 多</span>
                                </div>
                                <el-image class="pointer" @click="nextSlide(6)" style="width: 2%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in-linear">
                        <div v-show="show_section2_slide6 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="background-color: #3E2E22;display: flex;flex-direction: row;height: inherit">
                                <el-image style="width: 50%;height: 100%;" src="https://www.vibe-vape.com/images/shutterstock_1104499724_1.jpg" fit="cover" ></el-image>
                                <div style="width: 50%;height: 100%;"></div>
                            </div>
                            <el-image style="height: 46%;position: absolute;left:0; right:0;top: 27%" src="https://www.vibe-vape.com/images/CAP.png" fit="scale-down"></el-image>
                            <div class="right-detail">
                                <div class="right-detaiil-titel">
                                    <div>ICE COFFEE</div>
                                    <div>冰 醇 咖 啡</div>
                                </div>
                                <div class="right-detaiil-content">
                                    <div>咖啡的醇厚浓香与轻盈的冰凉口感美妙融合,</div>
                                    <div>随享冰醇一夏</div>
                                </div>
                                <div class="right-detaiil-buy" @click="toJd">立即购买</div>
                            </div>
                            <div class="detail-back">
                                <el-image class="pointer" style="width: 4%" src="https://www.vibe-vape.com/images/left-white.png" fit="cover" @click="show_section2_slide6 = 0"></el-image>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>

            <div class="section">
                <div class="slide">
                    <div style="width: 50%;position: absolute;left: 0;top: 0;bottom: 0">
                        <el-image class="slide-img" src="https://www.vibe-vape.com/images/PERSPECTIVE-VIEW_B.jpg" fit="scale-down" ></el-image>
                        <div class="six-flavors">
                            <div>四 色 多 彩 器 具</div>
                        </div>
                        <div class="know-more" @click="toJd">
                            <div>
                                <span class="pointer" @click="buyP1">了 解 更 多</span>
                            </div>
                            <el-image class="pointer" @click="buyP1" style="width: 4%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                        </div>
                    </div>
                    <div style="width: 50%;position: absolute;left: 50%;top: 0;bottom: 0">
                        <el-image class="slide-img" src="https://www.vibe-vape.com/images/shutterstock_A.jpg" fit="cover"></el-image>
                        <div class="six-flavors">
                            <div>六 种 惊 喜 口 味 雾 化 器</div>
                        </div>
                        <div class="know-more" @click="toJd">
                            <div>
                                <span class="pointer" @click="buyP2">了 解 更 多</span>
                            </div>
                            <el-image class="pointer" @click="buyP2" style="width: 4%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                        </div>
                    </div>
                </div>
            </div>

            <div class="section">
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section4_slide1 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="width: 50%;position: absolute;left: 0;top: 0;bottom: 0">
                                <el-image class="slide-img" src="https://www.vibe-vape.com/images/Words-of-Lord-text-effect.jpg" fit="cover"></el-image>
                            </div>
                            <div style="width: 50%;position: absolute;left: 50%;top: 0;bottom: 0;background-color: #1A1719">
                                <div class="center-detail">
                                    <div class="center-detaiil-titel">
                                        <div>万 铂 雾 化</div>
                                    </div>
                                    <div class="center-detaiil-content">
                                        <div>VIBE万铂雾化隶属于深圳市华洲海盛科技有限公司（以下简称华洲海盛）。</div>
                                        <div>华洲海盛的业务范围包含电子雾化装置销售、电子雾化液开发和供应以及高</div>
                                        <div>端香型定制等，拥有行业顶尖研发技术团队。</div>
                                    </div>

                                    <div class="center-detaiil-content">
                                        <div>VIBE万铂致力于以自主调香和超临界植粹技术为核心竞争力，推动电子雾</div>
                                        <div>化行业及雾化液技术通往更天然的方向发展。</div>
                                    </div>

                                    <div class="center-detaiil-content">
                                        <div>VIBE万铂倡导天然、健康的生活理念，专注研发以天然植物碱替代化学合成尼古</div>
                                        <div>丁盐的电子雾化产品。VIBE万铂的雾化液香型臻选来自全球各地的优质香料，经由</div>
										<div>具备30余年专业调香经验的资深技术人员反复调试、检测，确保雾化液口味的自然、醇正。</div>
                                    </div>

                                    <div class="center-detaiil-content">
                                        <div>VIBE万铂选择全球最大电子雾化设备制造商思摩尔为深度合作伙伴，由旗下拥</div>
                                        <div>有10个专业及大型生产基地、国内外专利申请超过1500项、其中已授权专利数量</div>
										<div>超过700项的思摩尔负责提供VIBE万铂雾化装置的硬件支持。</div>
                                    </div>

                                    <div class="center-detaiil-content">
                                        <div>VIBE万铂，高纯度，更顺滑，让每一次体验如沐春风，更为友好。</div>
                                    </div>
                                </div>
                                <div class="center-detaiil-more">
                                    <el-image style="width: 5%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover" @click="show_section4_slide1=1"></el-image>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in">
                        <div v-show="show_section4_slide1 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="width: 50%;position: absolute;left: 0;top: 0;bottom: 0;background-color: #1A1719">
                                <div class="center-detail" style="top: 30%">
                                    <div class="center-detaiil-titel" style="margin-bottom: 1%;">
                                        <div>VIBE 是氛围&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                    </div>
                                    <div class="center-detaiil-content" style="margin-top: 0;margin-bottom: 1%">
                                        <div>为您每一刻的感受营造充实的包围感</div>
                                        <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;每一丝情绪起伏都随着香气一一被诠释</div>
                                    </div>
                                    <div class="center-detaiil-titel" style="margin-bottom: 1%;">
                                        <div>是连接&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                    </div>
                                    <div class="center-detaiil-content" style="margin-top: 0;margin-bottom: 1%">
                                        <div>跟随纯粹香气更自然地打破边界&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                    </div>
                                    <div class="center-detaiil-titel" style="margin-bottom: 1%;">
                                        <div>是共鸣&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div>
                                    </div>
                                    <div class="center-detaiil-content" style="margin-top: 0;margin-bottom: 1%">
                                        <div>&nbsp;&nbsp;在愉悦的雾化氛围里引发联想和共情</div>
                                        <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;享受随心互动，让身心得以自在释放。</div>
                                    </div>
                                </div>
                                <div class="center-detaiil-more">
                                    <el-image style="width: 5%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover" @click="show_section4_slide1=2"></el-image>
                                </div>
                            </div>
                            <div style="width: 50%;position: absolute;left: 50%;top: 0;bottom: 0">
                                <el-image class="slide-img" src="https://www.vibe-vape.com/images/shutterstock_1219537795.png" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in">
                        <div v-show="show_section4_slide1 === 2" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="width: 50%;position: absolute;left: 0;top: 0;bottom: 0">
                                <el-image class="slide-img" src="https://www.vibe-vape.com/images/BUSINESS-MAN.jpg" fit="cover"></el-image>
                            </div>
                            <div style="width: 50%;position: absolute;left: 50%;top: 0;bottom: 0;background-color: #1A1719">
                                <div class="center-detail" style="top: 46%">
                                    <div class="center-detaiil-titel">
                                        <div>VIBE &nbsp;&nbsp;NEW</div>
                                    </div>
                                </div>
                                <div class="center-detaiil-more">
                                    <div style="margin-bottom: 2%">了 解 更 多</div>
                                    <el-image style="width: 5%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover"></el-image>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>

            <div class="section">
                <div class="slide">
                    <transition name="el-fade-in">
                        <div v-show="show_section5_slide1 === 0" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="width: 50%;position: absolute;left: 0;top: 0;bottom: 0">
                                <el-image class="slide-img" src="https://www.vibe-vape.com/images/Boxes-Packaging-RED.jpg" fit="cover"></el-image>
                            </div>
                            <div style="width: 50%;position: absolute;left: 50%;top: 0;bottom: 0;background-color: #1A1719">
                                <div class="center-detail" style="top: 25%">
                                    <div class="center-detaiil-titel">
                                        <div>VIBE 万铂雾化</div>
                                        <div>全球招募</div>
                                    </div>
                                    <div class="center-detaiil-content">
                                        <div>品牌赋能</div>
                                        <div>VIBE万铂 品牌授权</div>
                                    </div>
                                    <div class="center-detaiil-content">
                                        <div>产品授权</div>
                                        <div>VIBE万铂 全线产品售卖权</div>
                                    </div>
<!--                                    <div class="center-detaiil-content">-->
<!--                                        <div>品 牌 支 持</div>-->
<!--                                        <div>视 觉 设 计 及 物 料 支 持</div>-->
<!--                                    </div>-->
                                    <div class="center-detaiil-content">
                                        <div>营销支持</div>
                                        <div>品牌宣传及各类活动支持</div>
                                    </div>
                                </div>
                                <div class="center-detaiil-more">
                                    <div style="margin-bottom: 2%" @click="show_section5_slide1=1">立 即 申 请</div>
                                    <el-image style="width: 5%" src="https://www.vibe-vape.com/images/bottom.png" fit="cover" @click="show_section5_slide1=1"></el-image>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="el-fade-in">
                        <div v-show="show_section5_slide1 === 1" class="transition-box" :style="{'height': windowsHeight+'px'}" style="position: relative">
                            <div style="width: 50%;position: absolute;left: 0;top: 0;bottom: 0;background-color: #1A1719">
                                <div class="center-detail">
                                    <div class="center-detaiil-titel">
                                        <div>联 系 我 们</div>
                                    </div>
                                    <div class="center-detaiil-content">
                                        <div>客服热线：400-1892-528</div>
                                        <div>商务合作：bd@vibe-vape.com</div>
                                        <div>加入我们：hr@vibe-vape.com</div>
                                    </div>

                                    <div class="center-detaiil-content">
                                        <div>办公地址：深圳市南山区深圳湾科技生态园</div>
                                    </div>
                                    <div class="center-detaiil-content">
                                        <p></p>
                                    </div>
                                    <div class="center-detaiil-ewm">
                                        <div class="ewm-block" style="margin-right: 5%">
                                            <el-image class="ewm" src="https://www.vibe-vape.com/images/ewm1.png" fit="cover"></el-image>
                                            <p>官方微信</p>
                                        </div>
                                        <div class="ewm-block">
                                            <el-image class="ewm" src="https://www.vibe-vape.com/images/ewm2.png" fit="cover"></el-image>
                                            <p>官方微博</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="width: 50%;position: absolute;left: 50%;top: 0;bottom: 0">
                                <el-image class="slide-img" src="https://www.vibe-vape.com/images/Boxes-Packaging-RED.jpg" fit="cover"></el-image>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </full-page>

        <!--左边弹出层-->
        <div class="left-menu" @click="drawer = true">
            ||||
        </div>
        <el-drawer
                title=""
                :visible.sync="drawer"
                :direction="direction"
                size="11%">
            <div class="left">
                <el-image style="width: 100%;cursor: pointer" src="https://www.vibe-vape.com/images/left.png" fit="cover" @click="drawer=false"></el-image>
            </div>
            <el-tree :data="data" :render-after-expand="expand" :props="defaultProps" @node-click="handleNodeClick"></el-tree>

            <div class="drawe-logo">
                <transition name="el-fade-in">
                    <div v-show="logoShow" class="transition-box" @mouseenter="logoShow=false">
                        <el-image style="width: 100%;cursor: pointer" src="https://www.vibe-vape.com/images/logo.png" fit="cover"></el-image>
                    </div>
                </transition>
            </div>
            <div class="drawe-logo">
                <transition name="el-fade-in-linear">
                    <div v-show="!logoShow" class="transition-box" @mouseleave="logoShow=true">
                        <el-image style="width: 100%;cursor: pointer" src="https://www.vibe-vape.com/images/ewm-white.png" fit="cover"></el-image>
                    </div>
                </transition>
            </div>
        </el-drawer>

        <!--底部选择器-->
        <div class="bottom-line">
            <div class="bottom-line-l">Designed by kit design 2019</div>
            <div class="bottom-line-c">
                <a v-for="(i,index) in product[sectionIndex]" :class="[i.color,i.selected?'border-action':'']" :href="i.href" @click="chooseSlide(index)&resetView()"></a>
            </div>
            <div class="bottom-line-r">
<!--                <div>WECHAT</div>-->
<!--                <div>FACEBOOK</div>-->
<!--                <div style="padding-right: 40px;">INSTAGRAM</div>-->
            </div>
        </div>

        <!--18禁提示图-->
        <transition name="el-fade-in-linear">
            <div v-show="first" class="transition-box">
                <div class="first" @click="first=false">
                    <el-image style="height: 100%;cursor: pointer" src="https://www.vibe-vape.com/images/VIBE_WEBSITE_D.png" fit="cover"></el-image>
                </div>
            </div>
        </transition>

<!--        <div class="smoke-box">-->
<!--            <canvas id="myCanvas"></canvas>-->
<!--        </div>-->
    </div>
</template>

<script>
    import $ from 'jquery'
    export default {
        name: 'app',
        data() {
            return {
                options: {
                    licenseKey: '',
                    afterLoad: this.afterLoad,
                    scrollOverflow: true,
                    scrollBar: false,
                    navigation: true,
                    anchors: ['page1', 'page2', 'page3','page4','page5'],
                    sectionsColor: ['#000000', '#000000', '#000000','#000000', '#000000'],
                    controlArrows:false
                },
                //产品1 的底部颜色
                sectionIndex: 0,
                product:[
                    [
                        {color:'red',href:'#page1',selected:true},
                        {color:'blue',href:'#page1/1',selected:false},
                        {color:'white',href:'#page1/2',selected:false},
                        {color:'black',href:'#page1/3',selected:false},
                    ],
                    [
                        {color:'brown',href:'#page2',selected:false},
                        {color:'beige',href:'#page2/1',selected:false},
                        {color:'iron',href:'#page2/2',selected:false},
                        {color:'yellow',href:'#page2/3',selected:false},
                        {color:'wathet',href:'#page2/4',selected:false},
                        {color:'light-brown',href:'#page2/5',selected:false},
                    ],
                ],

                //弹出层组件
                drawer: false,
                direction: 'ltr',
                expand:false,
                //弹出层菜单
                data: [{
                    label: '产品中心',
                    children: [{
                        label: 'Vibe Pure',src:'page1'
                    },{
                        label: 'Vibe Pods',src:'page2'
                    },{
                        label: 'FEELM 4.0',src:'page1',index:4
                    }]
                }, {
                    label: '官方商城',src:'page3'
                }, {
                    label: '关于VIBE',src:'page4'
                }, {
                    label: '成为万客',src:'page5'
                }],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },

                first:true,
                logoShow:true,
                windowsHeight: 0,

                show_section1_slide1:0,
                show_section1_slide2:0,
                show_section1_slide3:0,
                show_section1_slide4:0,
                show_section1_slide5:0,

                show_section2_slide1:0,
                show_section2_slide2:0,
                show_section2_slide3:0,
                show_section2_slide4:0,
                show_section2_slide5:0,
                show_section2_slide6:0,

                show_section4_slide1:0,

                show_section5_slide1:0,

                inter:''
            }
        },
        mounted(){
            this.windowsHeight =   `${document.documentElement.clientHeight}`;
            // 获取浏览器可视区域高度
            let that = this;
            window.onresize = function temp() { that.resetHeight() };
            this.inter = setInterval(()=>{this.setFeel()},1000);
        },
        methods: {
            resetHeight(){
                this.windowsHeight = `${document.documentElement.clientHeight}`;
            },
            //加载完毕之后
            afterLoad(origin, destination, direction) {
                this.sectionIndex = destination.index
                //禁止鼠标向下和向上滚动
                // this.$refs.fullpage.api.setAllowScrolling(false,'down, up');
                //禁用键盘向下和向上滚动
                this.$refs.fullpage.api.setKeyboardScrolling(false, 'down, up, left, right');
                if (this.sectionIndex==0||this.sectionIndex==1) this.chooseSlide(0)
                this.resetView()
                this.resetSection()
            },

            //重置模块一和模块的显示
            resetSection(){
                if (this.sectionIndex===0){
                    this.$refs.fullpage.api.silentMoveTo('page1',0);
                } else if (this.sectionIndex===1){
                    this.$refs.fullpage.api.silentMoveTo('page2',0);
                }
            },

            //选择底部的颜色
            chooseSlide(index){
                //改变底部颜色
                let products = this.product[this.sectionIndex]
                for (let i in products) { products[i].selected = false }
                this.product[this.sectionIndex] = products
                this.product[this.sectionIndex][index].selected = true
            },
            //重置显示
            resetView(){
                if (this.sectionIndex===0){
                    this.show_section1_slide1 = 0
                    this.show_section1_slide2 = 0
                    this.show_section1_slide3 = 0
                    this.show_section1_slide4 = 0
                    this.show_section1_slide5 = 0
                } else if (this.sectionIndex===1){
                    this.show_section2_slide1 = 0
                    this.show_section2_slide2 = 0
                    this.show_section2_slide3 = 0
                    this.show_section2_slide4 = 0
                    this.show_section2_slide5 = 0
                    this.show_section2_slide6 = 0
                }else if(this.sectionIndex===3){
                    this.show_section4_slide1 = 0
                }else if(this.sectionIndex===4){
                    this.show_section5_slide1 = 0
                }
            },

            toEn: function () {
                this.$i18n.locale = 'en'
            },
            toZn: function () {
                this.$i18n.locale = 'zh'
            },

            handleNodeClick(data) {
                if (!data.src) return false
                if (data.src==='page1'&&data.index === 4) {
                    this.$refs.fullpage.api.silentMoveTo('page1',4);
                }else{
                    this.$refs.fullpage.api.moveTo(data.src,data.index?data.index:0);
                }
                /*收起*/
                this.drawer = false
                let that = this
                setTimeout(()=>{that.chooseSlide(data.index?data.index:0);that.resetView()},200)
            },

            //滑动下一张
            nextSlide(index){
                this.chooseSlide(index);
                this.$refs.fullpage.api.moveSlideRight();
            },

            toJd(){
                // window.open("https://mall.jd.com/index-10075603.html","_blank")
            },

            setFeel(){
                if ($(".el-tree-node__content:contains('FEELM 4.0')").css('height')) clearInterval(this.inter)
                $(".el-tree-node__content:contains('FEELM 4.0')").css('height','auto');
                $(".el-tree-node__label:contains('FEELM 4.0')").html('<img class="pointer" style="width: 10vh;padding: 5% 0;" src="https://www.vibe-vape.com/images/FEELM logo-02.png"/>')
            },

            buyP1(){
                return false
                this.show_section1_slide1 = 3
                this.show_section1_slide2 = 2
                this.show_section1_slide3 = 2
                this.show_section1_slide4 = 2
                this.$refs.fullpage.api.silentMoveTo('page1',0);
                let that = this
                setTimeout(()=>{that.chooseSlide(0)},200)
            },
            buyP2(){
                return false
                this.show_section2_slide1 = 2
                this.show_section2_slide2 = 1
                this.show_section2_slide3 = 1
                this.show_section2_slide4 = 1
                this.show_section2_slide5 = 1
                this.show_section2_slide6 = 1
                this.$refs.fullpage.api.silentMoveTo('page2',0);
                let that = this
                setTimeout(()=>{that.chooseSlide(0)},200)
            },
        }
    }
    // setTimeout(()=>{
    //     var myCanvas = document.getElementById('myCanvas');
    //     var ctx = myCanvas.getContext('2d');
    //     var arr = [];
    //
    //     function init() {
    //         myCanvas.width = window.innerWidth;
    //         myCanvas.height = window.innerHeight;
    //     }
    //     init();
    //
    //     window.onresize = init;
    //
    //     window.addEventListener('mousemove', function(e){
    //         // for (let i =0;i<10;i++){
    //             arr.push(new Circle(e.clientX, e.clientY));
    //         // }
    //     });
    //
    //     function Circle(x, y){
    //         this.x = x;
    //         this.y = y;
    //         this.vx = (Math.random() - 0.5) * 2;
    //         this.vy = (Math.random() - 0.5) * 2;
    //         // var r = random(0, 256);
    //         // var g = random(0, 256);
    //         // var b = random(0, 256);
    //         // this.color = 'rgb(' + r + ',' + g + ',' + b + ')';
    //         this.color = 'rgb(168,165,165)'
    //         this.a = 0.5;
    //         this.draw();
    //     }
    //
    //     Circle.prototype = {
    //         draw: function(){
    //             ctx.beginPath();
    //             // ctx.fillStyle = this.color;
    //             ctx.fillStyle = "rgba(0,0,0,0.05)";
    //             ctx.globalAlpha = this.a;
    //             // ctx.globalCompositeOperation = 'lighter';
    //             for (let i =0;i<10;i++){
    //                 ctx.arc(this.x, this.y, 1, 0, Math.PI * 2, 0);
    //             }
    //
    //             ctx.fill();
    //             this.move();
    //         },
    //         move: function(){
    //             this.x += this.vx;
    //             this.y += this.vy;
    //             this.a *= 0.98;
    //         }
    //     }
    //
    //     function render(){
    //         ctx.clearRect(0, 0, myCanvas.width, myCanvas.height);
    //         arr.forEach(function(ele, index){
    //             ele.draw();
    //             if(ele.a < 0.05){
    //                 arr.splice(index, 1);
    //             }
    //         })
    //
    //         //requestAnimationFrame(render);
    //         setTimeout(function(){
    //             render();
    //         }, 16.7)  //屏幕的刷新频率就是16.7毫秒
    //     }
    //     render();
    //
    //     function random(min, max){
    //         return Math.floor(Math.random() * (max - min) + min);
    //     }
    // },2000)
    // $(document).bind('mousemove touchmove',function(e) {
    //     e.preventDefault();
    //     var drawSize = 1;
    //     var drawType = '.';
    //     var floatType = 'floatOne';
    //     var xPos = e.originalEvent.pageX+20;
    //     var yPos = e.originalEvent.pageY-20;
    //
    //     $('body').append('<div class="draw" style=" font-size:'+drawSize+'px;left:'+xPos+'px;top:'+yPos+'px;-webkit-animation:'+floatType+' 1s 1;-moz-animation:'+floatType+' 1s 1;color:#f8f8f8;">'+drawType+'</div>');
    //
    //     $('.draw').each(function() {
    //         var div = $(this);
    //         setTimeout(function() {$(div).remove();},900);
    //     });
    // });
</script>
<style>
    /*全局字体*/
    @font-face
    {
        /* font-family: myFont;
        src: url('/font/SourceHanSansCN-Normal.ttf'); */
		font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Roboto,Source Han Sans SC,Noto Sans CJK SC,Segoe UI,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif;
    }

    /* 自定义饿了么组件*/
    .el-dialog__wrapper{
        bottom: 6.1%;
    }
    .el-drawer__header{
        display: none;
    }
    .el-drawer,.el-tree{
        font-family: myFont;
        background-color: #231F20;
        color: white;
    }
    .el-tree{
        letter-spacing: 6px;
        padding-left: 18%;
    }
    .el-tree-node__content{
        height: 6vmin;
        padding-left: 0!important;
        background-color: #231F20!important;
    }
    .el-tree-node__content:hover{
        background-color: #231F20;
    }
    .el-tree-node__label{
        font-size: 1.8vmin;
    }
    .el-tree-node__children .el-tree-node__content{
        height: 35px;
    }
    .el-tree-node__children .el-tree-node__label{
        color: #999A9A;
        font-size: 1.6vmin;
        letter-spacing: 3px;
    }
    .el-tree-node__content>.el-tree-node__expand-icon {
        padding: 0;
    }
    .el-tree-node__expand-icon{
        display: none;
    }

    .el-popup-parent--hidden{
        padding-right: 0!important;
    }

    #fp-nav ul li a span, .fp-slidesNav ul li a span{
        background: #ffffff;
    }

    /*自定义样式*/
    .first{
        position: fixed;
        left: 0;
        right: 0;
        top:0;
        bottom:0;
        background-color: #000000;
        z-index: 9999;
		display: flex;
		    display: -webkit-flex;
		    align-items: center;
		    justify-content: center;
    }
    .pointer{
        cursor: pointer;
    }
    .logo{
        position: fixed;
        width: 11%;
        left: 0;
        right: 0;
        top:3%;
        margin: auto;
        text-align: center;
        z-index: 70;
    }
    .language{
        font-family: myFont;
        color: white;
        font-size: 1.8vmin;
        font-weight: bold;
        display: flex;
        align-items: center;
        position: fixed;
        right: 3%;
        top:6%;
        margin: auto;
        text-align: center;
        z-index: 70;
    }
    .language-center{
        margin: 0 8px;
        font-size: xx-small;
        font-weight: bolder;
        font-family: myFont;
    }
    .left{
        width: 20%;
        margin: 40% 14%;
    }
    .drawe-logo{
        position: absolute;
        width: 70%;
        left: 0;
        right: 0;
        bottom:6%;
        margin: auto;
    }

    .left-menu{
        position: fixed;
        z-index:99;
        left: 2%;
        top: 3%;
        font-size: 4vmin;
        color: white;
        letter-spacing: -1px;
        cursor: pointer;
    }
    .slide-img{
        height: 100%;
        position: absolute;
        left: 0;
        right: 0;
    }
    .speciality{
        position: absolute;
        width: 10%;
        left: 0;
        right: 0;
        top:30%;
        height: 50%;
        margin: auto;
        cursor: pointer;
    }
    .sp-detail{
        font-size: 0.6vmin;
        color: #E4E2E3;
    }
    .sp-left{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 50%;
    }
    .sp-right{
         position: absolute;
         top: 0;
         bottom: 0;
         right: 0;
         left: 50%;
     }

    /*底部*/
    .bottom-line{
        background-color: #231F20;
        position: fixed;
        z-index: 2001;
        width: 100%;
        height: 6%;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    .bottom-line-l{
        flex: 1;
        color: #979796;
        font-style: italic;
        text-indent: 40px;
        font-size: 1vmin;
    }
    .bottom-line-c{
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
    .bottom-line-r{
        flex: 1;
        color: white;
        font-size: 1vmin;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
    }
    .bottom-line-r div{
        margin-left: 5%;
    }
    .bottom-line-c a{
        width: 3%;
        height: 0;
        padding-top: 3%;
        border-radius: 50%;
        margin: 0 15px;
        box-sizing: content-box;
    }
    .border-action{
        border: 2px solid #ffffff!important;
    }
    .red{
        background-color: #BE1D2C;
    }
    .blue{
        background-color: #0E65A3;
    }
    .white{
        background-color: #A8A9AD;
    }
    .black{
        background-color: #231F20;
        border: 1px solid #ffffff;
    }
    .brown{
        border: 1px solid #ffffff;
        background-color: #3E2E22;
    }
    .beige{
        background-color: #C4AF91;
    }
    .iron{
        background-color: #672720;
    }
    .yellow{
        background-color: #F7A945;
    }
    .wathet{
        background-color: #59A1CF;
    }
    .light-brown{
        background-color: #BE805F;
    }
    /**/
    .section{
        font-family: myFont;
    }
    .slide-mask{
        position: absolute;
        width: 100%;
        top: 0;
        bottom: 0;
        background-color: #000000;
        opacity: 0.3;
    }
    .let-be{
        position: absolute;
        left:0;
        right:0;
        bottom: 45%;
        color: white;
        text-align: center;
        font-size: 4vmin;
        cursor: pointer;
        letter-spacing: 2px
    }
    .know-more{
        position: absolute;
        left:0;
        right:0;
        bottom: 8%;
        color: white;
        text-align: center;
        font-size: 2.3vmin;
    }
    .free-logo{
        position: absolute;
        left:0;
        right:0;
        bottom: 7%;
        text-align: center;
    }
    .cap-line{
        position: absolute;
        width: 10%;
        left: 0;
        right: 0;
        top:30%;
        margin: auto;
        text-align: center;
    }
    .more-right{
        position: absolute;
        width: 3%;
        left: 59%;
        right: 0;
        top:46%;
        text-align: center;
        cursor: pointer;
    }
    .six-flavors{
        position: absolute;
        left:0;
        right:0;
        bottom: 20%;
        color: white;
        text-align: center;
        font-size: 4vmin;
        letter-spacing: 5px
    }
    .left-detail{
        position: absolute;
        top: 38%;
        right:50%;
        left: 0;
        color: white;
        text-align: center;
        letter-spacing: 2px;
    }
    .right-detail{
        position: absolute;
        top: 38%;
        left:50%;
        right: 0;
        color: white;
        text-align: center;
        letter-spacing: 2px;
    }
    .right-detaiil-titel{
        font-size: 3vmin;
        letter-spacing: 2px
    }
    .right-detaiil-content{
        margin-top: 3%;
        font-size: 2vmin;
    }
    .right-detaiil-buy{
        margin-top: 3%;
        font-size: 2vmin;
        cursor: pointer;
    }
    .detail-back{
        font-size: 4vmin;
        position: absolute;
        bottom: 10%;
        left:50%;
        right: 0;
        color: white;
        text-align: center;
    }

    .center-detail{
        position: absolute;
        top: 18%;
        right:0;
        left: 0;
        text-align: center;
        letter-spacing: 2px;
        color: #E4E2E3;
    }
    .center-detaiil-titel{
        font-size: 4vmin;
        letter-spacing: 2px;
        margin-bottom: 6%;
    }
    .center-detaiil-content{
        margin-top: 4%;
        font-size: 1.8vmin;
        font-weight: lighter;
    }
    .center-detaiil-more{
        position: absolute;
        left:0;
        right:0;
        bottom: 10%;
        color: #E4E2E3;
        text-align: center;
        font-size: 2.4vmin;
        cursor: pointer;
    }
    .center-detaiil-ewm{
        margin-top: 4%;
        font-size: 1.8vmin;
    }
    .ewm-block{
        display: inline-block;
        width: 20%;
    }
    .ewm{
        /*width: 50%;*/
    }

    /*烟雾*/
    .smoke-box{
        position: fixed;
        left: 0;
        right: 0;
        top:0;
        bottom:0;
        z-index: 9999;
        pointer-events: none;
    }
    .draw {
        position: fixed;
        width: 1px;
        line-height: 1px;
        pointer-events: none;
        z-index: 999;
        transform: translateZ(100px);
    }
    @keyframes floatOne {
        0% {
            opacity: 0;
            transform:translate3D(0, -2vmin, 0) scale(20) rotate(45deg);
        }
        5% {
            opacity: 0;
            transform:translate3D(0, -2vmin, 0) scale(18) rotate(45deg);
        }
        10% {
            opacity: 0;
            transform:translate3D(0, -2vmin, 0) scale(15) rotate(45deg);
        }
        20% {
            opacity:.1;
            transform:translate3D(0, -2vmin, 0) scale(13) rotate(45deg);
        }
        50% {
            opacity:.2;
            transform:translate3D(0, -2vmin, 0) scale(10) rotate(45deg);
        }
        70% {
            opacity:.3;
            transform:translate3D(0, -2vmin, 0) scale(5) rotate(45deg);
        }
        100% {
            opacity:.5;
            transform:translate3D(0, -2vmin, 0) scale(0) rotate(45deg);
        }
    }
</style>
